import { useAtom } from "jotai";

import {
  AvailableBudgetMixOptionsAtom,
  useGlobalMMMStore,
} from "../mmm-provider";

export const useAvailableBudgetMixOptions = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [availableBudgetMixOptions, setAvailableBudgetMixOptions] = useAtom(
    AvailableBudgetMixOptionsAtom,
    {
      store: GlobalMMMStore,
    },
  );

  return [availableBudgetMixOptions, setAvailableBudgetMixOptions] as const;
};
